import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link } from "react-scroll";
import { FiMenu, FiX } from "react-icons/fi";
import { FaEnvelope, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { IoMdRocket } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import logoPreto from "../assets/LOGO_PRETO.png";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const isSpecialPage = location.pathname !== "/" && location.pathname !== "/home";

  const handleLinkClick = () => {
    if (isSpecialPage) {
      navigate("/");
    }
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    if (location.pathname === "/" || location.pathname === "/home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/", { replace: true });
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <div className="header-top">
          <div className="left-icons">
            <FaWhatsapp /> <span>(31) 99087-0412</span>
          </div>
          <div className="header-message">
            <IoMdRocket size={18} className="rocket-icon" />
            <span>Fibra óptica premium para sua rotina</span>
          </div>
          <div className="right-icons">
            <FaEnvelope /> <span>contato@vitalink.com.br</span>
            <FaInstagram className="instagram-icon" /> <span>vitalinkcl</span>
          </div>
        </div>

        <div className="header-main">
          <div
            className="logo"
            onClick={handleLogoClick}
            style={{ cursor: "pointer" }}
          >
            <img src={logoPreto} alt="VitaLink" />
          </div>

          <nav className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
            <Link
              to="home"
              smooth
              duration={500}
              spy={!isSpecialPage}
              activeClass="active"
              className="nav-link"
              onClick={handleLinkClick}
            >
              Home
            </Link>
            <Link
              to="about"
              smooth
              duration={500}
              spy={!isSpecialPage}
              activeClass="active"
              className="nav-link"
              onClick={handleLinkClick}
            >
              Quem Somos
            </Link>
            <Link
              to="plans"
              smooth
              duration={500}
              spy={!isSpecialPage}
              activeClass="active"
              className="nav-link"
              onClick={handleLinkClick}
            >
              Planos
            </Link>
            <a
              href="https://www.speedtest.net/pt"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
            >
              Teste de Velocidade
            </a>
            <Link
              to="faq"
              smooth
              duration={500}
              spy={!isSpecialPage}
              activeClass="active"
              className="nav-link"
              onClick={handleLinkClick}
            >
              Dúvidas
            </Link>

            <div className="mobile-contacts">
              <button
                className="nav-link mobile-contact-link"
                onClick={() => {
                  navigate("/contact");
                  setIsMenuOpen(false);
                }}
              >
                Contato
              </button>
              <a
                href="https://portal.vitalinkcl.com.br/adm"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link mobile-login-link"
                onClick={() => setIsMenuOpen(false)}
              >
                Login
              </a>
            </div>
          </nav>

          <div className="header-buttons">
            <button
              className="contact-button"
              onClick={() => navigate("/contact")}
            >
              Contato
            </button>
            <a
              href="https://portal.vitalinkcl.com.br/adm"
              target="_blank"
              rel="noopener noreferrer"
              className="login-button"
            >
              Login
            </a>
          </div>

          <div className="menu-icon" onClick={toggleMenu}>
            {isMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
